import { render, staticRenderFns } from "./CreateTemplateModal.vue?vue&type=template&id=94c2ecc0"
import script from "./CreateTemplateModal.vue?vue&type=script&lang=js"
export * from "./CreateTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateModal.vue?vue&type=style&index=0&id=94c2ecc0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports